import { render, staticRenderFns } from "./PageABCBookCompleted.vue?vue&type=template&id=c0cc6702&scoped=true&"
import script from "./PageABCBookCompleted.vue?vue&type=script&lang=js&"
export * from "./PageABCBookCompleted.vue?vue&type=script&lang=js&"
import style0 from "./PageABCBookCompleted.vue?vue&type=style&index=0&id=c0cc6702&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cc6702",
  null
  
)

export default component.exports